import { TableCell } from '@mui/material';
import { styled as MuiStyled } from '@mui/material/styles';

const HeadTableCell = MuiStyled(TableCell)`
    color: ${(props) => props.theme.text.secondary.color};
    font-size: ${(props) => props.theme.typography.t3Bold.fontSize};
    font-weight: ${(props) => props.theme.typography.t3Bold.fontWeight};
    line-height: ${(props) => props.theme.typography.t3Bold.lineHeight};
`;

const LargeHeadTableCell = MuiStyled(TableCell)`
    color: ${(props) => props.theme.text.secondary.color};
    font-size: ${(props) => props.theme.typography.t2Bold.fontSize};
    font-weight: ${(props) => props.theme.typography.t2Bold.fontWeight};
    line-height: ${(props) => props.theme.typography.t2Bold.lineHeight};
`;

const BodyTableCell = MuiStyled(TableCell)`
    color: ${(props) => props.theme.text.primary.color};
    font-size: ${(props) => props.theme.typography.t2Bold.fontSize};
    font-weight: ${(props) => props.theme.typography.t2Bold.fontWeight};
    line-height: ${(props) => props.theme.typography.t2Bold.lineHeight};
    direction: ${(props) => props.dir};
`;

const LargeBodyTableCell = MuiStyled(TableCell)`
    color: ${(props) => props.theme.text.primary.color};
    font-size: ${(props) => props.theme.typography.t1Bold.fontSize};
    font-weight: ${(props) => props.theme.typography.t1Bold.fontWeight};
    line-height: ${(props) => props.theme.typography.t1Bold.lineHeight};
`;

export { BodyTableCell, HeadTableCell, LargeBodyTableCell, LargeHeadTableCell };
